"use client";
import { useEffect, useContext } from "react";
import { IndicatorsContext } from "../../(context)/IndicatorsContext";

export const useTwoLevelSelector = () => {
  let {
    data,
    setFilteredData,
    level1Value,
    level2Value,
    setLevelValue1,
    setLevelValue2,
    setDataSelector1,
    setDataSelector2,
    setLoading,
  } = useContext(IndicatorsContext);

  // Este efecto se ejecuta cuando se actualiza la variable data, que sólo va a pasar una vez
  // Setea los valores iniciales de los selectores
  useEffect(() => {
    if (data.length === 0) return;
    setLoading(true);
    const d1 = data.filter(({ index }) => index % 100 === 0);
    const inRange = data.filter(
      ({ index }) => index >= level1Value && index <= level1Value + 99
    );
    const d2 = inRange.filter(({ index }) => index);

    setDataSelector1(d1);
    setDataSelector2([{ index: -1, label: "Todos" }, ...d2]);

    setFilteredData(inRange);
    setLoading(false);
  }, [data]);

  // Esta función se ejecuta cuando se cambia el valor del primer selector
  // Actualiza el segundo y tercer selector
  const handleOnChangeLevel1 = (val) => {
    setLoading(true);

    const value = parseInt(val, 10);
    setLevelValue1(value);
    setLevelValue2(-1);

    const inRange = data.filter(
      ({ index }) => index >= value && index <= value + 99
    );
    setFilteredData(inRange);

    const d2 = inRange.filter(({ index }) => index % 1 === 0);
    const dataSelector2Aux = [{ index: -1, label: "Todos" }, ...d2];
    setDataSelector2(dataSelector2Aux);

    setLoading(false);
  };

  // Esta función se ejecuta cuando se cambia el valor del segundo selector
  // Actualiza el tercer selector
  const handleOnChangeLevel2 = (val) => {
    setLoading(true);
    const value = parseInt(val, 10);
    setLevelValue2(value);
    if (value === -1) {
      handleOnChangeLevel1(level1Value);
      return;
    }
    const inRange = data.filter(({ index }) => index === value);
    setFilteredData(inRange);
    setLoading(false);
  };

  return {
    handleOnChangeLevel1,
    handleOnChangeLevel2,
  };
};
